module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAAAECAYAAADCtRJuAAAAIElEQVQ4jWNkzNj+n2EU4AVMA+2AoQBGA4kIMBpIRAAAxmUCJxsaIwsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/矩形.png
// module id = vaDI
// module chunks = 1